import apiClient from '@/services/axios'

export async function get(folderId) {
  var response = await apiClient.get('/folders/' + folderId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get folder.')
}
